import axios from "axios";
import BASE_URL from "../../../constants/baseURL";

export default async function signOut(_, { getState }) {
  const { memberDetails } = getState();

  sessionStorage.clear();
  localStorage.removeItem("authToken");
  localStorage.removeItem("auth_token_with_guard");
  localStorage.removeItem("visitorDataID");
}
